import {CancelButton} from '@hconnect/uikit/src/lib2'
import {Check} from '@mui/icons-material'
import {LoadingButton} from '@mui/lab'
import {DialogTitle, DialogContent, Dialog, TextField} from '@mui/material'
import DialogActions from '@mui/material/DialogActions'
import {TFunction} from 'i18next'
import {trim} from 'lodash'
import React, {useEffect, useState} from 'react'

import {MAX_COMMENT_LENGTH} from './comments.consts'
import {CommonComment, EditCommentProps} from './comments.types'

interface CommentEditDialogProps {
  open: boolean
  handleOpen: (open: boolean) => void
  comment: CommonComment
  editCommentProps: EditCommentProps
  translate: TFunction
}

export const CommentEditDialog: React.FC<CommentEditDialogProps> = ({
  open,
  handleOpen,
  comment,
  editCommentProps,
  translate
}) => {
  const [commentValue, setCommentValue] = useState(comment.text)
  const handleSubmit = () => {
    editCommentProps.onEdit(comment.id, trim(commentValue))
  }
  const onEnter = () => {
    setCommentValue(comment.text)
  }
  const handleClose = () => {
    handleOpen(false)
  }

  useEffect(() => {
    if (!editCommentProps.savingChangesInProgress) {
      handleOpen(false)
    }
  }, [editCommentProps.savingChangesInProgress, handleOpen])

  return (
    <Dialog fullWidth open={open} TransitionProps={{onEnter}} data-test-id="comment-edit-dialog">
      <DialogTitle>{translate('comments.editDialog.title')}</DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          variant={'filled'}
          label={translate('comments.label.enterComment')}
          multiline
          value={commentValue}
          inputProps={{
            maxLength: MAX_COMMENT_LENGTH,
            'data-test-id': 'comment-edit-dialog-comment-field'
          }}
          onChange={(event) => {
            setCommentValue(event.target.value)
          }}
          data-test-id={'comment-dialog-comment-field'}
        />
      </DialogContent>
      <DialogActions sx={{padding: 3}}>
        <CancelButton onClick={handleClose} data-test-id="comment-dialog-cancel-btn">
          {translate('comments.action.cancel')}
        </CancelButton>
        <LoadingButton
          variant="contained"
          onClick={handleSubmit}
          disabled={!trim(commentValue) || trim(commentValue) === comment.text}
          startIcon={<Check />}
          data-test-id="comment-dialog-save-btn"
          loading={editCommentProps.savingChangesInProgress}
          loadingPosition={'start'}
        >
          {translate('comments.action.save')}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
